export class ResultModel<T = any> {
    Success:boolean;
    Message:string;
    data: T;
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
    role:string;

    public constructor(success?:boolean, message?:string, data?: T){
        this.Success = success;
        this.Message = message;
        this.data = data;
    }

}